// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconCheck = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7">
            <path
                fill="currentColor"
                d="M3.69317845,6.86253779 L8.868173,1.46499381 C9.04390233,1.28168998 9.04390233,0.984515052 8.868173,0.801229128 L8.23179146,0.137464443 C8.05606212,-0.0458214811 7.77112208,-0.0458214811 7.59539275,0.137464443 L3.37498768,4.53935245 L1.40457725,2.4842118 C1.22884792,2.30090797 0.943907876,2.30090797 0.768178542,2.4842118 L0.131797,3.14797648 C-0.0439323334,3.33128031 -0.0439323334,3.62845524 0.131797,3.81174117 L3.05679691,6.86251989 C3.23250907,7.04582372 3.51743195,7.04582372 3.69317845,6.86253779 Z"
            />
        </svg>
    );
};

export default React.memo(IconCheck);
